import React, { useState } from 'react';
import { Search, ChevronDown } from 'lucide-react';
import ContentListView from './ContentListView';
import ManualScrapingView from './ManualScrapingView';

export default function WebScraping() {
  const [mode, setMode] = useState('list');

  return (
    <div className="bg-gray-800 p-6 rounded-2xl shadow-lg border border-gray-700 flex flex-col h-full max-w-4xl mx-auto">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2 className="text-3xl font-semibold text-cyan-300 mb-1 flex items-center gap-3">
            <Search /> Web Scraping
          </h2>
          <p className="text-gray-400">
            {mode === 'list'
              ? 'Browse content from the data source.'
              : 'Manually scrape data from URLs or search.'}
          </p>
        </div>
        <div className="relative">
          <select
            value={mode}
            onChange={(e) => setMode(e.target.value)}
            className="bg-gray-700 border border-gray-600 rounded-lg py-2 pl-4 pr-10 appearance-none focus:outline-none focus:ring-2 focus:ring-cyan-500"
          >
            <option value="list">Content List</option>
            <option value="manual">Manual Scraping</option>
          </select>
          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
        </div>
      </div>
      {mode === 'list' ? <ContentListView /> : <ManualScrapingView />}
    </div>
  );
}

